import * as React from "react";
import { Alert, AlertTitle, AlertDescription } from "../ui/alert";
import { Button } from "../ui/button";
import { AlertCircle, RefreshCcw } from "lucide-react";
import { useState } from "react";

const ErrorState = ({
  error,
  title = "Something went wrong",
  description = "We encountered an error while loading the data.",
  backgroundColor,
}) => {
  const [key, setKey] = useState(0);

  const resetError = () => {
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <div
      key={key}
      className="min-h-[400px] flex items-center justify-center p-4"
    >
      <Alert
        variant="destructive"
        className="max-w-md"
        style={{ backgroundColor }}
      >
        <AlertCircle className="h-5 w-5" />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription className="mt-2">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            {description}
            {error && (
              <span className="block mt-2 text-xs font-mono">
                Error: {error.message || error}
              </span>
            )}
          </p>
          {/* <Button variant="outline" onClick={resetError} className="w-full">
            <RefreshCcw className="mr-2 h-4 w-4" />
            Try again
          </Button> */}
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default ErrorState;
